import { useMemo } from 'react'
import { MULTIPLE_CONNECTIONS_FOUND } from 'Data/common-constants'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    let [connection] = data || []

    if (connection?.status === MULTIPLE_CONNECTIONS_FOUND) return connection

    return []
  }, [data])
}
